<template>
  <div class="dashboard-container">
    <a-row :gutter="20" class="bootcamp">
      <a-col :span="isDesktop ? 16 : 24">
        <a-card title="Getting Started With TrueLife.org" class="style1">
          <div class="quotes-wrapper">
            <span class="ant-card-head-title" style="white-space: break-spaces;">
              <q>Then I heard the voice of the Lord, saying, 'Whom shall I send, and who will go for Us?' Then I said, Here I am. Send me!</q> -Isaiah 6:8-9
            </span>
          </div>
          <iframe :src="videoUrl" width="640" height="400" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </a-card>
        <a-card :title="pageDescription.title">
          <p>
            <strong v-text="pageDescription.es_title"></strong>
          </p>
          <div class="page-description-content" v-html="pageDescription.content"></div>
        </a-card>
      </a-col>
      <a-col :span="isDesktop ? 8 : 24">
        <a-card title="">
          <p style="text-align: center; font-size: 26px;">Fund the Revival You<br />Have Been Praying For!</p>
          <iframe
            src="https://donorbox.org/embed/jesusstory?default_interval=m"
            name="donorbox"
            allowpaymentrequest=""
            seamless="seamless"
            frameborder="0"
            scrolling="no"
            height="550px"
            width="100%"
            style="max-width: 500px; min-width: 250px; max-height: none !important;"
          ></iframe>
          <label style="font-size: 14px; line-height: 1.1rem;">We are a 501(c) organization if you need a tax exempt path to donate please email, Donate@TrueLife.org.</label>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PageService from '@/services/PageService';
export default {
  data: () => ({
    pageDescription: [],
  }),
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    videoUrl() {
      return this.instructionVideo('I_MAIN_DASHBOARD_LINK');
    },
  },
  async created() {
    this.pageDescription = await PageService.getPageBy('dashboard-detail-for-jesus');
  },
};
</script>

<style lang="scss">
.dashboard-container {
  padding: 20px;
  .bootcamp {
    text-align: center;
    p {
      text-align: left;
    }
    button {
      height: auto;
      padding: 10px;
      text-transform: capitalize;
    }
  }
}
</style>
